
/* START_TEMPLATE */
define('hbs!app/templates/_payment_method_subview_div',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<div data-name=\"PaymentMethod\" data-subview=\"payment_method_view\" data-subview-index=\"-1\" data-cache-key=\"PaymentMethod\" />";
  }});
Handlebars.registerPartial('app/templates/_payment_method_subview_div', t);
Handlebars.registerPartial('./_payment_method_subview_div', t);
return t;
});
/* END_TEMPLATE */
;
